export const SOCIAL_LINKS = [
    {
        href: 'https://www.instagram.com/motorverseab/',
        icon: 'fa-brands fa-instagram',
        label: 'Instagram'
    },
    {
        href: 'https://x.com/themotorverse',
        icon: 'fa-brands fa-x-twitter',
        label: 'Twitter'
    },
    {
        href: 'https://discord.com/invite/themotorverse',
        icon: 'fa-brands fa-discord',
        label: 'Discord'
    }
];

export const CURRENT_YEAR = new Date().getFullYear();
